<template>
  <div id='afterQuestion'>
       <div class="notify" >
          <!-- <div class='title'>NUTRIPACKS</div>
          <div class='title'> <span>个性化</span>营养评估量表</div>
          <div class='line'></div>
          <div class='notifyTxtBox'>
                <div class='notifyTxt'>• 超过<span>100000</span>份营养数据支持</div>
                <div class='notifyTxt'>• 规避常见药物作用风险(<span>DNIs</span>)</div>
                <div class='notifyTxt'>• <span>5-10</span>分钟生成评估报告与方案</div>
          </div>
          <div class='app-btn app-btn-red btn' @click='toReport'>查看报告</div> -->
          <img class="placeholder" :src="loadImg">
             <div class="description" >{{stateNum}}%</div>
          </img>
             
             <div class="statetitleBox">
				 <div class="statetitle"></div>
                   <div class="statetitle" :class="setp1" >同态加密处理</div>
                   <div class="statetitle" :class="setp2" >深度算法处理</div>
                   <div class="statetitle" :class="setp3" >正在生成报告</div>
             </div>
             <div class="edition" >算法版本号：V116.201</div>
      </div>
        
  </div>
</template>

<script>

export default {
  name: 'afterQuestion',
  props: {
    countid:String,
  },
  data:function(){
    return{
		loadImg:"https://admin.xiaojudai.cn/static/common/images/rec_generating.gif",
		setp1:"",
		setp2:"",
		setp3:"",
		stateNum:0,
    }
  },
 
 created:function(){
	this.stateNum=0
	this.startAnimation()
	
  },
  
  methods: {
		toReport(){
		  this.$router.push({name: 'reportDetail',params: {id:this.countid}});
		},
		startAnimation(){
	      this.stateTime()
	    },
	    stateTime(){
	      let that = this
	      if (that.stateNum == 10) {
	          that.setp1="statecenter"
	      }
	      if (that.stateNum==40){
	          that.setp1= "stateleft"
	          that.setp2= "statecenter"
	     
	      }
	      if (that.stateNum == 70) {
	     
	          that.setp2= "stateleft"
	          that.setp3= "statecenter"
	     
	      }
	      if (that.stateNum>99){
				that.toReport()
	        return
	      }
	      setTimeout(()=>{
	        that.stateNum=Number(that.stateNum) + 1
	        that.stateTime()
	      },50)
	    }
  }
}
</script>  

<style>
#afterQuestion{
  width: 7.5rem;
  height: 100vh;
  overflow: hidden;
  position: relative;
  z-index: 200;
  background-color: #F4F2F0;
}
#afterQuestion .notify {
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    width: 5.74rem;
    min-height:8rem;
    box-sizing: border-box;
    padding: 0.93rem 0.87rem;
    text-align: center;
    border-radius:0.1rem;
    box-shadow: 0px 50px 50px -20px rgba(236, 163, 129, 0.288);
    background-color: #fff;
}

#afterQuestion .title {
    font-size:0.4rem;
    font-family:SourceHanSansCN-Medium,SourceHanSansCN;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height:0.62rem;
    text-align: left;
}
#afterQuestion .title span{
  color: rgba(183, 137, 117, 1);
}
#afterQuestion .line{
  width:0.88rem;
  height:0.12rem;
  background:rgba(194,94,77,1);
  border-radius:0.09rem;
  margin:0.5rem 0;
}
#afterQuestion .notifyTxtBox{
  margin-bottom: 1rem;
}
#afterQuestion .notifyTxtBox .notifyTxt{
    font-size:0.24rem;
    font-family:SourceHanSansCN-Regular,SourceHanSansCN;
    font-weight:400;
    color:rgba(80,80,80,1);
    line-height:0.56rem;
    text-align: left;
}
#afterQuestion .notifyTxtBox .notifyTxt span{
  font-weight: bold;
}
#afterQuestion .btn{
  width: 4rem;
  border-radius:0.45rem;
  height:0.7rem;
  line-height: 0.7rem;
  box-sizing: border-box;
  padding: 0;
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 0.24rem;
}

#afterQuestion .placeholder {
	display: block;
    width: 2.68rem;
    height:2.68rem;
    margin: 0 auto;
    position: relative;
}
#afterQuestion  .description{
  position: absolute;
  top:29%;
  left:50%;
  text-align: center;
  line-height: 1rem;
  height: 1rem;
  width: 2rem;
  font-weight: 600;
  font-size: 0.38rem;
  transform: translate(-50%,-50%);
}

#afterQuestion .mongolia{
    width: 7.5rem;
    height: 100vh;
    background-color: RGBA(244, 242, 240, 1);
    z-index: 99;
     position: fixed;
}
#afterQuestion .statetitleBox{
  position: relative;
  height: 1rem;
  width:100%;
}
#afterQuestion .statetitle{
   
    width:5.76rem;
	height: 2rem;
	line-height: 2rem;
    text-align: center;
    font-size: 0.38rem;
    font-weight: 600;
    position: absolute;
    right:-2rem;
    top:0;
    opacity: 0;
    transition: all 0.5s;
}
#afterQuestion .statecenter{
  right:-0.87rem;
  opacity: 1;
}
#afterQuestion .stateleft{
  right:7.5rem;
  opacity: 0;
}
#afterQuestion .edition{
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  font-size: 0.26rem;
  text-align: center;
  height: 2rem;
  line-height: 2rem;
}

</style>